import { Component, Input } from '@angular/core';
import { BrandKey, brandKeyFor, socialLabelFor } from './social-brands';

/**
 * Renders one social icon from a CMS `social_name`.
 *
 * Brands with no glyph in Font Awesome 4.7.0 (currently just X) are drawn as
 * inline SVG at `currentColor`; everything else keeps the existing
 * `<i class="fa fa-{{name}}">` so no other icon on the site is disturbed.
 */
@Component({
  selector: 'raksme-brand-icon',
  templateUrl: './brand-icon.component.html',
  styleUrls: ['./brand-icon.component.css']
})
export class BrandIconComponent {

  public name: string = '';
  public brandKey: BrandKey | null = null;
  public label: string = '';

  /** 'lg' matches Font Awesome's own `size="lg"` (1.333em), used by the share buttons. */
  @Input() size: '' | 'lg' = '';

  @Input('name')
  set setName(_name: string) {
    this.name = _name;
    this.brandKey = brandKeyFor(_name);
    this.label = socialLabelFor(_name);
  }
}
